import React from 'react';

import MuiFormControlLabel, {
  FormControlLabelProps as MuiFormControlLabelProps,
} from '@mui/material/FormControlLabel';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const FormControlLabel = withCoreProps<FormControlLabelProps>(
  ({ className, ...props }: React.PropsWithChildren<FormControlLabelProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return <MuiFormControlLabel {...props} className={clsxClass} />;
  },
);

export interface FormControlLabelProps
  extends MuiFormControlLabelProps,
    CoreProps {}
